import { getToken, getUserInfo, getUserIp } from "@/common/cookies";
import { UserService } from "@/services";

export default defineNuxtPlugin(async (nuxtApp) => {
  const { $store, $cookies } = useNuxtApp();
  const route = useRoute();
  const router = useRouter();

  // 需要登录的路由前缀
  const requiredLoginPre = ["my"];

  const mustRedirectToMyPrefix = ["sign", "reset"];

  const isMatchPath = (name, prefixList) => {
    return prefixList.includes(name?.split("-")[0] || name);
  };

  /**
   * @description 应用全局初始化中间件，用于初始化信息保存到vuex中
   */

  // url replace
  const onHandleUrlReplace = () => {
    // console.log('当前url', route.fullPath)
    const fullPath = route.fullPath;
    const insertStr = "/";
    // // safari的正则需要是 RegExp 对象的形式
    // // const prefixRegx = /^[^\\#\\?]+/;
    // // const replaceRegx = /^.*(?<!\/)$/;
    const prefixRegx = new RegExp("^[^\\\\#\\\\?]+");
    const replaceRegx = new RegExp("/$");

    let prefixUrl = fullPath.match(prefixRegx)[0];

    const isApiUrl = prefixUrl.indexOf("/sharkfoto/") !== -1;
    const isMatched = !replaceRegx.test(prefixUrl);
    console.log(
      "前缀正则:",
      prefixRegx,
      "替换正则:",
      replaceRegx,
      "前缀URL:",
      prefixUrl,
      "是否需要补斜杠:",
      isMatched
    );
    if (isMatched && !isApiUrl) {
      const resultUrl = fullPath.replace(prefixUrl, `${prefixUrl}${insertStr}`);
      console.log(fullPath, "没有带斜杆, 跳转到:", resultUrl);
      router.push(resultUrl);
    }
  };

  // reffer重定向
  const onHandleReffer = () => {
    // /r/的形式 如果手动截取，易错率高 采取?r=的形式更加符合url的规范
    // const path = route.path
    // const isMatchRefferPrefix = path.indexOf('/r/') !== -1
    const reffer = route.query?.r;
    if (reffer) {
      // 动态设置Cookie域名（SSR 安全）
      const getCookieDomain = () => {
        if (__CUSTOM_ENV__ !== "production") {
          return "";
        }

        const currentDomain =
          typeof window !== "undefined" && window.location
            ? window.location.hostname
            : "";

        if (!currentDomain) {
          return "";
        }

        // 如果是AWS域名，不设置domain让Cookie在当前域名下生效
        if (currentDomain.includes(".pages.dev")) {
          return "";
        }

        // 如果是sharkfoto.com域名，设置为.sharkfoto.com
        if (currentDomain.includes("sharkfoto.com")) {
          return ".sharkfoto.com";
        }

        return "";
      };

      $cookies.set("sharkfoto_reffer_id", reffer, {
        path: "/",
        maxAge: 7 * 24 * 60 * 60,
        domain: getCookieDomain(),
      });
      router.push("/");
    }
  };

  // page页重定向
  const onHandlePaging = () => {
    const page = route.params?.page || "";
    if (page && +page === 1) {
      const fullPath = route.fullPath.replace("page-1/", "");
      router.push(fullPath);
    }
  };

  // 初始化应用
  const initApplication = async () => {
    const token = getToken();
    const userInfo = getUserInfo();
    const userIp = getUserIp();

    if (token && $store) {
      $store.commit("user/SET_TOKEN", token);
      userInfo && $store.commit("user/SET_USER_INFO", JSON.parse(userInfo));
    }

    if (!userIp && $store) {
      try {
        const result = await UserService.getUserIp();
        if (result.status === 200) {
          $store.commit("common/SET_USER_IP", result.data);
        }
      } catch (error) {
        console.error("获取用户IP失败:", error);
      }
    } else if ($store) {
      $store.commit("common/SET_USER_IP", userIp);
    }

    if (token && $store) {
      $store.commit("user/SET_TOKEN", token);
    }
  };

  const onRedirect = () => {
    // url replace
    onHandleUrlReplace();
    // reffer
    onHandleReffer();
    // page-1
    onHandlePaging();
  };

  // 等待应用挂载完成
  await nuxtApp.hook("app:mounted", async () => {
    await initApplication();
    // onRedirect();
  });
});
